import * as React from 'react';

type PlayArrowSvgProps = React.SVGProps<SVGSVGElement> & {
  width?: number;
  height?: number;
};

const PlayArrowSvg: React.FC<PlayArrowSvgProps> = ({ width = 28, height = 28, ...props }) => {
  return (
    <svg
      width={width}
      height={height}
      {...props}
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="PlayArrowSvg"
    >
      <path
        d="M9.3335 20.0376V7.96257C9.3335 7.63201 9.45016 7.35493 9.6835 7.13132C9.91683 6.9077 10.1891 6.7959 10.5002 6.7959C10.5974 6.7959 10.6995 6.81048 10.8064 6.83965C10.9134 6.86882 11.0154 6.91257 11.1127 6.9709L20.621 13.0084C20.796 13.1251 20.9272 13.2709 21.0147 13.4459C21.1022 13.6209 21.146 13.8056 21.146 14.0001C21.146 14.1945 21.1022 14.3792 21.0147 14.5542C20.9272 14.7292 20.796 14.8751 20.621 14.9917L11.1127 21.0292C11.0154 21.0876 10.9134 21.1313 10.8064 21.1605C10.6995 21.1896 10.5974 21.2042 10.5002 21.2042C10.1891 21.2042 9.91683 21.0924 9.6835 20.8688C9.45016 20.6452 9.3335 20.3681 9.3335 20.0376ZM11.6668 17.9084L17.7918 14.0001L11.6668 10.0917V17.9084Z"
        fill="white"
      />
    </svg>
  );
};

export default PlayArrowSvg;
